<h2 mat-dialog-title>Sustainability Entry</h2>

<div mat-dialog-content *ngIf="step === 0" [formGroup]="transportSelectionForm">
  <div class="unit-toggle">
    <label>Unit:</label>
    <mat-button-toggle-group
      [value]="unitType"
      (change)="toggleUnit($event.value)"
      appearance="standard"
      exclusive
    >
      <mat-button-toggle value="Kilometers">Kilometers</mat-button-toggle>
      <mat-button-toggle value="Miles">Miles</mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <div class="month-year-row" style="display:flex; gap:12px; margin-top:8px;">
    <mat-form-field appearance="fill" style="width:140px;" hideRequiredMarker>
      <mat-label style="font-weight:400;">Month</mat-label>
      <mat-select formControlName="month">
        <mat-option *ngFor="let m of availableMonths" [value]="m.value" [disabled]="isFutureMonthSelected(m.value, transportSelectionForm?.value?.year || currentYear)">{{ m.label }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="fill" style="width:120px;" hideRequiredMarker>
      <mat-label style="font-weight:400;">Year</mat-label>
      <mat-select formControlName="year">
        <mat-option *ngFor="let y of years" [value]="y">{{ y }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="floating-select-scroll-wrapper">
    <div class="floating-select-wrapper" [class.ng-select-focused]="isTransportFocused">
      <label
        class="floating-label"
        [class.active]="isTransportFocused || transportSelectionForm.controls['transportModes'].value?.length"
      >
      </label>
      <ng-select
        [formControl]="transportSelectionForm.controls['transportModes']"
        [items]="transportModes"
        bindLabel="name"
        [multiple]="true"
        placeholder="Select Transport Modes"
        [disabled]="isSelectionDisabled()"
        (focus)="isTransportFocused = true"
        (blur)="isTransportFocused = false"
        appendTo="body"
      >
      </ng-select>
    </div>
  </div>


  <div mat-dialog-actions class="dialog-action-bar">
    <button mat-flat-button class="custom-cancel-button" (click)="onCancel()">Cancel</button>
    <button
      mat-flat-button
      class="custom-apply-button"
      [disabled]="transportSelectionForm.invalid || isSelectionDisabled()"
      (click)="onNextFromSelection()"
    >
      Next
    </button>
  </div>
</div>

<div mat-dialog-content *ngIf="step === 1" [formGroup]="transportDetailForm">
  <h3>Details for {{ currentModeName }} ({{ unitType }})</h3>

  <div class="custom-line-input">
    <label for="distance">Distance ({{ unitType }})</label>
    <input
      id="distance"
      type="number"
      formControlName="distance"
      step="0.1"
      [min]="isWorkFromHomeSelected() ? 0 : 0.1"
      [max]="maxDistance"
      required
      [readonly]="isWorkFromHomeSelected()"
      [class.work-from-home-distance]="isWorkFromHomeSelected()"
    />
    <!--  Validation errors -->
    <div class="error" *ngIf="transportDetailForm.get('distance')?.touched && transportDetailForm.get('distance')?.invalid">
  <span *ngIf="transportDetailForm.get('distance')?.hasError('required')">
    Distance is required
  </span>
  <span *ngIf="transportDetailForm.get('distance')?.hasError('min') && !isWorkFromHomeSelected()">
    Distance must be at least 0.1 {{ unitType }}
  </span>
  <span *ngIf="transportDetailForm.get('distance')?.hasError('max')">
    Distance cannot be more than {{ maxDistance }} {{ unitType }}
  </span>
</div>
  </div>

  <div class="custom-line-input">
    <label for="commutingDays">{{ commutingDaysLabel }}</label>
    <input
      id="commutingDays"
      type="number"
      formControlName="commutingDays"
      min="1"
      max="5"
      step="1"
      required
    />
     <!-- Validation errors -->
    <div class="error" *ngIf="transportDetailForm.get('commutingDays')?.touched && transportDetailForm.get('commutingDays')?.invalid">
      <span *ngIf="transportDetailForm.get('commutingDays')?.hasError('required')">
        {{ isWorkFromHomeSelected() ? 'WFH days is required' : 'Commuting days is required' }}
      </span>
      <span *ngIf="transportDetailForm.get('commutingDays')?.hasError('min')">
        Must be at least 1 day
      </span>
      <span *ngIf="transportDetailForm.get('commutingDays')?.hasError('max')">
        Cannot be more than 5 days in a work week
      </span>
      <span *ngIf="transportDetailForm.get('commutingDays')?.hasError('pattern')">
        {{ isWorkFromHomeSelected() ? 'WFH days cannot be a decimal' : 'Commuting days cannot be a decimal' }}
      </span>
    </div>
  </div>

  <div mat-dialog-actions class="dialog-action-bar">
    <button mat-flat-button class="custom-cancel-button" (click)="onCancel()">Cancel</button>
    <button mat-flat-button class="custom-back-button" (click)="onBack()">Back</button>
    <button
      mat-flat-button
      class="custom-apply-button"
      [disabled]="transportDetailForm.invalid"
      (click)="onNextTransportDetails()"
    >
      {{ currentTransportIndex < selectedTransportModes.length - 1 ? 'Next' : 'Apply' }}
    </button>
  </div>
</div>
